import { Rectangle } from 'jspdf';
import { BlockProps, IBlockLocation } from '../../content-blocks/type';
import { RectangleBlockProps } from './type';

interface Props {
  key: string;
  label: string;
  location: IBlockLocation;
}

export const createRectangleBlock = (props: Props): RectangleBlockProps => {
  return {
    type: 'rectangle',
    value: props.label,
    width: 10,
    height: 10,
    isVisible: false,
    x: 0,
    y: 0,
    fontSize: 12,
    isBold: false,
    isItalics: false,
    isCapsLocks: false,
    ...props,
  };
};

export function isRectangleBlock(
  block: BlockProps,
): block is RectangleBlockProps {
  return block.type === 'rectangle';
}
